import { router } from "@inertiajs/react";
import { trackEvent } from "./analytics";
import { trackMetaCustomEvent } from "./metaPixel";

export const trackEvaluationButtonClick = ({
  page_type,
}: {
  page_type: string;
}) => {
  trackEvent({
    name: "Évaluer mon véhicule",
    params: {
      category: "Interaction",
      action: "Click",
      label: "Évaluer mon véhicule",
      page_type: page_type,
    },
  });

  trackMetaCustomEvent("Évaluer mon véhicule", {
    page_type: page_type,
  });
};

export const handleEvaluationButtonClick = ({
  page_type,
}: {
  page_type: string;
}) => {
  trackEvaluationButtonClick({ page_type });
  router.visit("/reviews/new");
};
